/**
 * s-reveal: fades and slides in its [data-reveal] children as they scroll into view.
 * Anything already on screen when it connects is marked revealed straight away, so nothing on screen is ever hidden.
 * Does nothing (everything stays visible) for reduced motion or without IntersectionObserver.
 */
class SReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    const items = [...this.querySelectorAll('[data-reveal]')];
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const waiting = items.filter((item) => {
      const box = item.getBoundingClientRect();
      const onScreen = box.top < viewportHeight && box.bottom > 0;
      if (onScreen) item.setAttribute('data-revealed', '');
      return !onScreen;
    });
    if (!waiting.length) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-revealed', '');
        this.observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    waiting.forEach((item) => this.observer.observe(item));
    this.setAttribute('data-reveal-armed', '');
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeAttribute('data-reveal-armed');
  }
}

if (!customElements.get('s-reveal')) customElements.define('s-reveal', SReveal);
